import axios from 'axios'

var qs = require("qs")
var root = process.env.API_ROOT


/**
 * 获取当前时间的 yyyy-MM-dd的格式
 * @returns {string}
 */
export const getNowFormatDate = (params) => {
  var date = new Date();
  if(params&&params=='preday') {
    date.setTime(date.getTime() - 24 * 60 * 60 * 1000);
  }
  var seperator1 = "-";
  var year = date.getFullYear();
  var month = date.getMonth() + 1;
  var strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  var currentdate = year + seperator1 + month + seperator1 + strDate;
  return currentdate;
}

/**
 * 或当前时间的上一个月的日期
 * @param date
 * @returns {string}
 */
export const getPreMonth = (date) => {
  var arr = date.split('-');
  var year = arr[0]; //获取当前日期的年份
  var month = arr[1]; //获取当前日期的月份
  var day = arr[2]; //获取当前日期的日
  var days = new Date(year, month, 0);
  days = days.getDate(); //获取当前日期中月的天数
  var year2 = year;
  var month2 = parseInt(month) - 1;
  if (month2 == 0) {
    year2 = parseInt(year2) - 1;
    month2 = 12;
  }
  var day2 = day;
  var days2 = new Date(year2, month2, 0);
  days2 = days2.getDate();
  if (day2 > days2) {
    day2 = days2;
  }
  if (month2 < 10) {
    month2 = '0' + month2;
  }
  var t2 = year2 + '-' + month2 + '-' + day2;
  return t2;
}

/**
 * 对象数组排序 ，array：对象数组；key:某个属性
 * @returns {string}
 */
export const sortByKey = (array, key) => {
  return array.sort(function (a, b) {
    var x = a[key];
    var y = b[key];
    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
  });
}




// WEBPACK FOOTER //
// ./src/api/dateUtil.js